import { render, staticRenderFns } from "./ProfilesInClickhouse.vue?vue&type=template&id=0685605b&scoped=true"
import script from "./ProfilesInClickhouse.vue?vue&type=script&lang=js"
export * from "./ProfilesInClickhouse.vue?vue&type=script&lang=js"
import style0 from "./ProfilesInClickhouse.vue?vue&type=style&index=0&id=0685605b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0685605b",
  null
  
)

export default component.exports